module.exports = __webpack_public_path__ + "media/Varilux_ESERIES_STAIRS.d272b1e7.mp4";